export default "__VITE_ASSET__47243dd7__"